import { create } from 'zustand';
import type {
	OsobyKomunikacniUdajeDto,
	OsobyPodnikatelSeznamDto,
	OsobyFyzickaOsobaDto,
} from '@gov-nx/api';
import { prop, propEq } from '@gov-nx/core/types';
import type { PersonState } from './store.types';
import { isAdult } from './utils';

const initialState = {
	communication: undefined,
	business: undefined,
	individual: undefined,
};

const usePersonStoreBase = create<PersonState>()((set) => ({
	...initialState,

	setPersonCommunicationData: (communication: OsobyKomunikacniUdajeDto) =>
		set({ communication }),
	setBusinessPersonData: (business: OsobyPodnikatelSeznamDto) =>
		set({ business }),
	setIndividualPersonData: (individual: OsobyFyzickaOsobaDto) =>
		set({ individual }),
	personReset: () => set({ ...initialState }),
}));

export const usePersonStore = <T extends keyof PersonState>(
	property: T
): PersonState[T] => usePersonStoreBase(prop(property));

export const usePersonStoreBusiness = () => {
	const business = usePersonStore('business');

	return {
		poBusinessDataPO: business?.seznam?.filter(propEq('typ', 'PO')) ?? [],
		poBusinessDataPFO: business?.seznam?.find(propEq('typ', 'PFO')),
	};
};

export const usePersonStoreIndividual = () => {
	const individual = usePersonStore('individual');

	return {
		address: individual?.adresaPobytu,
		isAdult: isAdult(individual?.vek),
	};
};

export const usePersonStoreCommunication = () => {
	const communication = usePersonStore('communication');

	return {
		emailVerified: communication?.email,
		unverifiedEmail: communication?.emailOvereni,
		phoneVerified: communication?.telefonniCislo,
		unverifiedPhone: communication?.telefonniCisloOvereni,
	};
};
